import ls from 'localstorage-slim'
import { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router'

import { AccountPreferenceKeys, OnboardingStatus, Theme } from '@ankor-io/common/types/account'
import { updateThemeMode } from '@ankor-io/common/util/updateThemeMode'

import { useUserContext } from '@/providers/user/useUserContext'
import { Layout } from '@/views/components/Layout'

const App: React.FC = () => {
  const { preferences, organizations } = useUserContext()
  const navigate = useNavigate()

  useEffect(() => {
    // TODO: Add logic to check if the user has an org/has completed onboarding, and navigate as needed
    // navigate('/onboarding')
  }, [navigate])

  // Upon page load, check if the user has a light mode preference in local storage
  useEffect(() => {
    // Read from browser local storage. If it exists, use it. If not, use user preference.
    const storageValue: Theme | null = ls.get('prefers-color-scheme')
    if (storageValue) {
      updateThemeMode(storageValue)
    } else if (preferences?.[AccountPreferenceKeys.THEME]) {
      updateThemeMode(preferences[AccountPreferenceKeys.THEME] as Theme)
    }
  }, [preferences])

  useEffect(() => {
    if (!Object.keys(preferences).length) {
      return
    }

    // Check for onboarding status
    const requireOnboarding =
      (Object.keys(organizations).length <= 1 &&
        preferences[AccountPreferenceKeys.ONBOARDING_STATUS] === OnboardingStatus.NOT_STARTED) ||
      preferences[AccountPreferenceKeys.ONBOARDING_STATUS] === OnboardingStatus.IN_PROGRESS

    if (requireOnboarding) {
      navigate('/onboarding')
    }
  }, [preferences, navigate, organizations])

  return (
    <Layout>
      <Outlet />
    </Layout>
  )
}

export default App
